import { Controller } from 'stimulus';

/**
 * Disables the current VIP's residence in the "Move to location" select
 * when a VIP is selected in the "Resident to move" select.
 */
export default class extends Controller {
  static targets = ['vipSelect', 'residenceSelect'];
  static values = { vipsData: Object };

  connect() {
    this.updateResidenceOptions();
  }

  vipChanged() {
    this.updateResidenceOptions();
  }

  updateResidenceOptions() {
    const selectedVipId = this.vipSelectTarget.value;

    if (!selectedVipId) {
      this.enableAllResidenceOptions();
      return;
    }

    // Get the VIP's current residence_id from the vipsData
    const currentResidenceId = this.vipsDataValue[selectedVipId];

    // Enable all options first
    this.enableAllResidenceOptions();

    // Disable the current residence option if it exists
    if (currentResidenceId) {
      const optionToDisable = this.residenceSelectTarget.querySelector(
        `option[value="${currentResidenceId}"]`
      );

      if (optionToDisable) {
        optionToDisable.disabled = true;

        // If the disabled option is currently selected, reset to blank
        if (
          this.residenceSelectTarget.value === currentResidenceId.toString()
        ) {
          this.residenceSelectTarget.value = '';
        }
      }
    }
  }

  enableAllResidenceOptions() {
    const options = this.residenceSelectTarget.querySelectorAll('option');
    options.forEach((option) => {
      option.disabled = false;
    });
  }
}
